import React, {Component} from 'react';
import lookups from '../lookups.json'; //lookup tables for all the possible choices
import './Dialogs.min.css';

export class CustomDialog_1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }
    validateInput() {
        var valid = true;
        var error_msg = null;
        var input = document.querySelector(".dlg_input_text");
        if(input.value.trim() == ""){
            valid = false;
            error_msg = "Please enter your custom options in the text box above"
        }
        this.setState({
            error: error_msg
        });
        if(valid){
            //create table of the current configuration

            var html = "";
            html+="<div><b>Name:</b> " + this.props.customer.firstName + " " + this.props.customer.lastName + "</div>";
            html+="<div><b>Email:</b> " + this.props.customer.email + "</div>";
            html+="<div><b>Phone:</b> " + this.props.customer.phone + "</div>";
            html+="<div><b>Custom Options:</b> " + document.querySelector("#dlg_textarea").value + "</div>";
            html+="<div style='margin-top: 1em;'><b>Configuration:</b>";
            html+="<table style='margin-left:0;'><tbody>";
            html+="<tr><td style='font-weight:bold;'>Actuator</td><td>" + this.props.at + "</td></tr>";

            //create table of the current configuration
            for(var i = 0; i < this.props.data.parameters.length; i++){
                var choices=[];
                var choice = this.props.data.parameters[i].choice;
                var arrChoices=this.props.data.parameters[i].choices.split(",");
                if(arrChoices[0] == "all"){
                    choices = this.props.lookups.options[i].choices;
                }else{
                    for(var j = 0; j < arrChoices.length; j++){
                        choices.push(this.props.lookups.options[i].choices[arrChoices[j]]);
                    }
                }
                html+="<tr><td style='font-weight:bold;'>" + this.props.data.parameters[i].title + "</td><td>" + choices[choice].title + "</td></tr>";
            }

            html+="</tbody></table>";


        //save SF data
        var url_sf = this.props.urlDW2 + "/Integration?run=MTS_244_Sales&Transition=CustomQuote";

        var customer = [];
        customer.push("CustFirstName=" + this.props.customer.firstName);
        customer.push("CustLastName=" + this.props.customer.lastName);
        customer.push("CustEmail=" + this.props.customer.email);
        customer.push("CustCompany=" + this.props.customer.company);
        customer.push("CustPhone=" + this.props.customer.phone);
        customer.push("CustCountry=" + this.props.customer.country);
        customer.push("CustProject=" + this.props.customer.projectName);
        customer.push("CustOptions=" + document.querySelector("#dlg_textarea").value);
        url_sf+= "&" + customer.join("&");

        
        for(var i = 0; i < this.props.data.parameters.length; i++){
            url_sf+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice + 1)); 
        }
                   
        var iframe = document.querySelector("#test_iframe");
        iframe.src = url_sf; //send current setup to second iframe tied to another instance of the DW stuff
        console.log("sent = " + url_sf);


            //call email webservice to send Custom Options email to internal MTS staff
            /* const options = {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    mailfrom: "MTS 3D Studio <design_studio@mts.com>",
                    mailto: "mdebrey@discerncx.com", //Design_studio@mts.com
                    subject: "Custom Options Request",
                    header: "Custom Options Request",
                    subtitle: "Custom Options request by a 3D Studio user",
                    html: html
                })
            };

            fetch(this.props.urlSite + '/nodemailer/server.js', options).catch(err => {
                console.error('Request failed', err)
            }); */

            this.props.onClick('custom_2');
        }
    }
    render() {
        return (
            <div id="dlg_custom_1" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Request Custom Options</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_grey">
                            <p className="dlg_head">Please list your desired custom options in the box below.  Your request will be forwarded to an MTS representative for review.</p>
                            <p><textarea maxLength="255" id="dlg_textarea" className="dlg_input_text"></textarea></p>
                            <div className="dlg_error" style={{fontWeight: "bold", display: this.state.error == null ? "none" : "block"}}>{this.state.error}</div>
                        </div>
                        <div id="dlg_custom_btn_1" className="dlg_btn" onClick={() => this.validateInput()}>REQUEST CUSTOM OPTIONS</div>
                    </div>
                </div>
            </div>
        );
    }
}

export class CustomDialog_2 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="dlg_custom_2" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <div className="dlg_logo"><img src="images/mtsLogo.png" /></div>
                        <div className="dlg_title_txt">Request Custom Options</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <p className="dlg_head">Your Custom Options Request Has Been Received</p>
                            <p>Your request will be forwarded to an MTS representative.  A sales representative will contact you using the information you provided.</p>
                            <p>MTS sales support is available Monday thru Friday (excluding holidays) 8 am - 6 pm CST.  You will receive a response within three business hours of your submission.</p>
                            <p>If you have any questions or concerns, please call MTS at (800) 328-2255.</p>
                        </div>
                        <div id="dlg_custom_btn_2" className="dlg_btn" onClick={() => this.props.onClick('null')}>CLOSE</div>
                    </div>
                </div>
            </div>
        );
    }
}
